import React from 'react'

interface SelectAllHeaderProps {
  selectedCount: number
  scopeValues: (string | number)[]
  currentValues: (string | number)[]
  onToggle: () => void
}

export default function SelectAllHeader({
  selectedCount,
  scopeValues,
  currentValues,
  onToggle,
}: SelectAllHeaderProps) {
  const isAllSelected =
    scopeValues.length > 0 &&
    scopeValues.every((v) => currentValues.includes(v as never))

  return (
    <div
      style={{
        padding: '8px 12px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <span style={{ fontSize: 12, color: '#677786' }}>
        {selectedCount ? `${selectedCount} selected` : 'All (default)'}
      </span>
      <span
        style={{
          fontSize: 12,
          color: '#1890ff',
          cursor: scopeValues.length ? 'pointer' : 'not-allowed',
          opacity: scopeValues.length ? 1 : 0.5,
          userSelect: 'none',
        }}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onToggle}
      >
        {isAllSelected ? 'Clear' : 'Select all'}
      </span>
    </div>
  )
}
